// DadosPessoais.js — "Dados Pessoais" virou uma seção com sub-abas.
//
// ================= POR QUE (pedido do dono, 11/09/2026) =================
//
// A barra lateral tinha nove itens, e três deles eram a mesma coisa: os DADOS
// da pessoa (perfil, endereço de entrega, senha). Separados, cada um virava uma
// linha a mais no menu; juntos numa página só, a rolagem passava de três telas
// — o formulário de perfil, mais quatro endereços, mais a troca de senha.
//
// Aqui eles são quatro sub-abas de uma seção só: o menu lateral encolheu e
// cada página ficou do tamanho de um assunto.
//
// AS CHAVES ANTIGAS CONTINUAM VALENDO. Telas espalhadas pelo site disparam
// `changePerfiltab` com "enderecos" e "seguranca" (o checkout manda cadastrar
// endereço, por exemplo), e o Perfil traduz isso para esta seção já aberta na
// sub-aba certa — ver a prop `inicial`.
import React, { useEffect, useState } from "react";
import SeletorDeSecao from "../Sidebar/SeletorDeSecao";
import MeusDados from "../meusDados/MeusDados";
import EnderecosEntrega from "../enderecos/EnderecosEntrega";
import SenhaSeguranca from "../seguranca/SenhaSeguranca";

const ABAS = [
  { chave: "perfil", rotulo: "Perfil", icone: "bi-person" },
  { chave: "redes", rotulo: "Redes e preferências", icone: "bi-link-45deg" },
  { chave: "enderecos", rotulo: "Endereços de entrega", icone: "bi-house-add" },
  { chave: "seguranca", rotulo: "Senha e segurança", icone: "bi-lock" },
];

const DadosPessoais = ({ inicial = "perfil", onSair }) => {
  const [aba, setAba] = useState(inicial);

  // O atalho de outra tela (ex.: "cadastre um endereço", vindo do checkout)
  // chega depois desta seção já estar montada.
  useEffect(() => { setAba(inicial); }, [inicial]);

  return (
    <div>
      {/* As sub-abas. Rolam na horizontal no celular — quatro rótulos não cabem
          em 360px, e quebrá-los em duas linhas empurraria o formulário para
          baixo da dobra, que é justamente o que esta divisão veio resolver. */}
      {/* `pl-4 pr-4` no lugar de `px-4`, e `mb-6` no lugar de `mb-5`: o
          Bootstrap declara `px-0..5` e `mb-0..5` com !important, então o
          `px-4` valia 24px contra os 16px do `-mx-4` (a barra nascia 8px para
          dentro da margem que ela deveria sangrar) e o `mb-5` abria 48px
          debaixo das abas. Os nomes `pl-*`/`pr-*` não existem no Bootstrap 5
          — ele usa `ps`/`pe` —, e a escala dele para de 5. */}
      {/* CELULAR: o mesmo seletor em folha do menu da conta (pedido do dono em
          18/09/2026, depois de ver o de cima). Quatro rótulos não cabem em
          360px, e a trilha rolável cortava o último na borda — de onde vinha a
          sensação de "duas barras confusas". Agora é uma linha só, e a folha
          mostra os quatro por extenso.
          A FILEIRA DE PÍLULAS CONTINUA NO COMPUTADOR: lá os quatro cabem, e
          trocar de aba num clique é melhor do que em dois. */}
      <div className="mb-6 md:hidden">
        <SeletorDeSecao
          rotulo="Dados pessoais"
          titulo="Dados pessoais"
          grupos={[{ titulo: "", itens: ABAS.map((a) => ({ key: a.chave, label: a.rotulo, icon: a.icone })) }]}
          atual={(() => {
            const a = ABAS.find((x) => x.chave === aba);
            return a && { key: a.chave, label: a.rotulo, icon: a.icone };
          })()}
          estaAtivo={(item) => item.key === aba}
          aoEscolher={(item) => setAba(item.key)}
        />
      </div>

      <div className="-mx-4 pl-4 pr-4 md:mx-0 md:pl-0 md:pr-0 mb-6 overflow-x-auto hidden md:block">
        {/* A trilha NÃO é um `.bloco`: bloco é contêiner de SEÇÃO, e dar a
            borda de 2px do cartão a uma barra de quatro botões faria a barra
            competir com o formulário que ela serve. É um sulco: hairline,
            `navy-soft/60` (mais claro que o fundo da página nos dois temas) e
            raio de painel, com os botões em raio de controle dentro.

            A ABA ATIVA NÃO SE DISTINGUE SÓ PELA COR. O laranja chapado era o
            único sinal: quem não separa laranja de navy via quatro botões
            iguais. Agora a ativa também vem em `font-bold` contra o
            `font-medium` das outras — 700 contra 500 se lê em preto e branco. */}
        <div className="flex w-max gap-1.5 rounded-painel border border-line bg-insigne-navy-soft/60 p-1">
          {ABAS.map((a) => (
            <button
              key={a.chave}
              type="button"
              onClick={() => setAba(a.chave)}
              aria-pressed={aba === a.chave}
              className={
                "foco-laranja inline-flex items-center gap-2 whitespace-nowrap rounded-controle px-3.5 py-2 " +
                "text-sm transition-colors " +
                (aba === a.chave
                  ? "bg-insigne-orange font-bold text-paper"
                  : "font-medium text-white/65 hover:bg-white/5 hover:text-white")
              }
            >
              <i className={"bi " + a.icone} />
              {a.rotulo}
            </button>
          ))}
        </div>
      </div>

      {aba === "perfil" && <MeusDados secao="perfil" />}
      {aba === "redes" && <MeusDados secao="redes" />}
      {aba === "enderecos" && <EnderecosEntrega />}
      {aba === "seguranca" && <SenhaSeguranca onDeleted={onSair} />}
    </div>
  );
};

export default DadosPessoais;
